import { configureStore } from '@reduxjs/toolkit'
import companyReducer from './companyslice'

export const store = configureStore({
  reducer: {
    company: companyReducer,
  },
})